import React, { PureComponent } from 'react';

class Header extends PureComponent {

    render() {

        const { vistaCliente, cuentaDenominacion, cuentaDescripcion } = this.props;
        let denominacion = vistaCliente.client.RazonSocial;
        let administradora = vistaCliente.GET_ADMINISTRADORA[0].Descripcion;
        let denominacionCuenta = cuentaDenominacion + " (" + cuentaDescripcion + ")";

        return (
            <div className="row bottom-separator-xs">
                <div className="col-md-9">
                    <label className="label-primary">{denominacion}   ❯   {administradora}   ❯   {denominacionCuenta}</label>
                </div>

                {/* ICONO DE EXPORTAR, IMPRIMIR Y ELIMINAR
                <div className="col-xs-1">
                    <span className="glyphicon glyphicon-file" aria-hidden="true"></span>
                </div>
                    <div className="col-xs-1">
                        <span className="glyphicon glyphicon-print" aria-hidden="true"></span>
                    </div>
                    <div className="col-xs-1">
                        <span className="glyphicon glyphicon-trash" aria-hidden="true"></span>
                    </div>*/}
            </div>
        );
    }
}

export default Header;